import MultiAddInput from "../../../common/js/components/MultiAddInput";
import LicenseDetail from "./LicenseDetail";

const LicenseInformation = (props) => {
    const { licenses, disableInputs, handleAddArrayElement, handleDeleteArrayElement, handleUpdateArrayElement } =
        props;

    return (
        <div>
            <MultiAddInput
                addButtonText="Add License"
                buttonType={"card"}
                disableInputs={disableInputs === true}
                displayFirstWhenEmpty={false}
                elements={licenses}
                onAdd={() => handleAddArrayElement("licenses")}
                onUpdate={(e, index) => handleUpdateArrayElement("licenses", index, e.target.id, e.target.value)}
                render={(element, elementIndex) => (
                    <LicenseDetail
                        element={element}
                        elementIndex={elementIndex}
                        onDelete={(index) => handleDeleteArrayElement("licenses", index)}
                        {...props}
                    />
                )}
            />
        </div>
    );
};

export default LicenseInformation;
